import React from 'react';
import './Layout.css';
import NavButtons from './NavButtons/NavButtons';

function Layout({ children }) {
  return (
    <div className="layout">
      {/* Header */}
      <header className="resume-header">
        <h1 className="headline">The Data Infrastructure for Human Insight</h1>
        <p className="subhead">
          Built by <strong>Joseph W.P. Bodden Jr.</strong> — Data Engineer • Developer • Architect
        </p>
        <p className="contact">
          <a href="mailto:joeitguy@gmail.com">joeitguy@gmail.com</a> • (619) 438‑3236 • San Diego, CA •{' '}
          <a href="https://linkedin.com/in/joe-bodden" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
        </p>
      </header>

      {/* Mission Statement */}
      <section className="mission">
        <p className="mission-text">
          <strong>"Built to support. Wired to solve."</strong>
        </p>
      </section>

      {/* Navigation */}
      <div className="nav-wrapper">
        <NavButtons />
      </div>

      {/* Main Content */}
      <main className="main-content">{children}</main>

      {/* Footer */}
      <footer className="footer">
        <p>© 2026 Joseph W.P. Bodden Jr. — Building with Purpose</p>
        <p className="tech-stack">
          React • Flask • Postgres • Docker • Heroku • Salesforce Platform
        </p>
      </footer>
    </div>
  );
}

export default Layout;
